module.exports = __webpack_public_path__ + "img/energy-1.2.05ce0294.svg";